
import * as api from "../constant/NewAPI";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import { all_routes } from "../router/all_routes";
import * as XLSX from "xlsx";

// import * as api from "../constant/API";
import Utils from "../constant/Utils";

const studentReport = () => {

    const routes = all_routes;

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState('');
    const [institutionList, setInstitutionList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [instituteId, setInstituteId] = useState('');
    const [classId, setClassId] = useState(null);
    const [sectionId, setSectionId] = useState(null);
    const [showTable, setShowTable] = useState(false);
    const [linkClicked, setLinkClicked] = useState(false);

    useEffect(() => {
        getInstitutionList()
    }, []);

    function getInstitutionList() {
        const instList = api.GeneralInstituteList + '/' + roleId //"?userId=" + userId + "&roleId=" + roleId;
        fetch(instList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instResponse) => instResponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (instResult.data != null) {
                        setInstitutionList(instResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error);
            })
    }

    function getClass(instid) {
        const getclslist = api.GetClass + '/' + instid // "?insId=" + instid;
        fetch(getclslist, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((clsResponse) => clsResponse.json())
            .then((clsResult) => {
                if (clsResult.error == true) {
                    if (clsResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (clsResult.data != null) {
                        setClassList(clsResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch class list", error);
            })
    }

    function getSection(clsid) {
        const getseclist = api.GetSection + '/' + clsid + '/' + instituteId // "?insId=" + instituteId + "&classId=" + clsid;
        fetch(getseclist, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((secResponse) => secResponse.json())
            .then((secResult) => {
                if (secResult.error == true) {
                    if (secResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (secResult.data != null) {
                        setSectionList(secResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch section list", error)
            })
    }

    function studReport() {
        const getStudReport = api.GetStudentReport + '/' + classId + '/' + sectionId + '/' + instituteId //"?insId=" + instituteId + "&classId=" + classId + "&sectionId=" + sectionId;
        fetch(getStudReport, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((studResponse) => studResponse.json())
            .then((studResult) => {
                if (studResult.error == true) {
                    if (studResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (studResult.data != null) {
                        setStudentList(studResult.data)
                    }
                    setShowTable(true)
                    setLinkClicked(true)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch student report", error);
            })
    }

    const filteredData = studentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const nameRender = (rowData, column) => {
        return <span>{rowData.studentName}</span>
    };

    const genderRender = (rowData, column) => {
        return <span>{rowData.coreUserGender}</span>
    };

    const classRender = (rowData, column) => {
        return <span>{rowData.ClassName}</span>
    };

    const sectionRender = (rowData, column) => {
        return <span>{rowData.SectionsName}</span>
    };

    const dobRender = (rowData, column) => {
        return <span>{formatDate(rowData.coreUserDOB)}</span>
    };

    const parentRender = (rowData, column) => {
        return <span>{rowData.coreUserParentName}</span>
    };

    const phoneRender = (rowData, column) => {
        return <span>{rowData.coreUserPhone}</span>
    };

    const sportRender = (rowData, column) => {
        return <span>{rowData.SportName}</span>
    };

    const programRender = (rowData, column) => {
        return <span>{rowData.ProgramName}</span>
    };

    const acheivementRender = (rowData, column) => {
        return <span>{rowData.coreUserAchievement}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const exportToExcel = () => {
        const formData = new FormData();
        formData.append("institutionId", instituteId);
        formData.append("classId", classId);
        formData.append("sectionId", sectionId);
        const exportRpt = api.StudentReportExport;
        fetch(exportRpt, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData,
        })
            .then((exportReponse) => exportReponse.json())
            .then((exportResult) => {
                if (exportResult.error == true) {
                    if (exportResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "Student Report.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to export Student Report", error);
            })
    }

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Student Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-secondary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row court-sortby sortbyset">
                                                                    <div className="col-lg-4 mb-10">
                                                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                                                        <Select
                                                                            value={institutionList.find(inst => inst.institutionId === instituteId) ? {
                                                                                value: instituteId,
                                                                                label: institutionList.find(inst => inst.institutionId === instituteId).institutionName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setInstituteId(e.value);
                                                                                getClass(e.value)
                                                                            }}
                                                                            options={institutionList.map(inst => ({
                                                                                value: inst.institutionId,
                                                                                label: inst.institutionName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <div style={{ marginTop: "1.8rem" }}>
                                                                            <Link to="#" className="btn btn-primary close" style={{ padding: "7px 60px" }} onClick={studReport}>
                                                                                <i className="fas fa-save"></i>View All Students
                                                                            </Link>
                                                                            <span>
                                                                                Or Choose a class and a section below:
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-4 mb-10">
                                                                        <label className="sortbytitle"><h6>Class</h6></label>
                                                                        <Select
                                                                            value={classList.find(cls => cls.classId === classId) ? {
                                                                                value: classId,
                                                                                label: classList.find(cls => cls.classId === classId).className
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setClassId(e.value);
                                                                                getSection(e.value);
                                                                            }}
                                                                            options={classList.map(cls => ({
                                                                                value: cls.classId,
                                                                                label: cls.className
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                    <div className="col-lg-4 mb-10">
                                                                        <label className="sortbytitle"><h6>Section</h6></label>
                                                                        <Select
                                                                            value={sectionList.find(sec => sec.sectionId === sectionId) ? {
                                                                                value: sectionId,
                                                                                label: sectionList.find(sec => sec.sectionId === sectionId).sectionName
                                                                            } : null}
                                                                            onChange={(e) => {
                                                                                setSectionId(e.value);
                                                                            }}
                                                                            options={sectionList.map(sec => ({
                                                                                value: sec.sectionId,
                                                                                label: sec.sectionName
                                                                            }))}>
                                                                        </Select>
                                                                    </div>
                                                                    <div className="col-lg-2 col-sm-12 table-search-top">
                                                                        <Link
                                                                            to="#"
                                                                            className="btn btn-secondary"
                                                                            onClick={studReport}
                                                                        >
                                                                            Submit
                                                                        </Link>
                                                                    </div>
                                                                    <div className="col-lg-2 col-sm-12 table-search-top">
                                                                        <Link
                                                                            to="#"
                                                                            className='btn btn-secondary'
                                                                            onClick={exportToExcel}
                                                                        >
                                                                            Export to Excel
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                {showTable && (
                                                                    <>
                                                                        <div className="col-md-12">
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="dataTables_filter">
                                                                                <label>
                                                                                    <input
                                                                                        type="text"
                                                                                        value={searchInput}
                                                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                                                        placeholder="Search"
                                                                                        className="form-control"
                                                                                    />
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {showTable && (
                                                            <>
                                                                <div className="tab-content">
                                                                    <div
                                                                        className="tab-pane fade show active"
                                                                        id="nav-Recent"
                                                                        role="tabpanel"
                                                                        aria-labelledby="nav-Recent-tab"
                                                                        tabIndex={0}
                                                                    >
                                                                        <div className="table-responsive table-datatble">
                                                                            <DataTable
                                                                                className="table datatable"
                                                                                value={filteredData}
                                                                                paginator
                                                                                rows={10}
                                                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                pageLinkSize={3}
                                                                            >
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="slNo"
                                                                                    body={slNoRender}
                                                                                    header="Sl No"
                                                                                // headerStyle={{ backgroundColor: "#0f2a4e", color: "#FFFF" }}
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="studentName"
                                                                                    body={nameRender}
                                                                                    header="Student Name"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coreUserGender"
                                                                                    body={genderRender}
                                                                                    header="Gender"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="ClassName"
                                                                                    body={classRender}
                                                                                    header="Class"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="SectionsName"
                                                                                    body={sectionRender}
                                                                                    header="Section"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coreUserDOB"
                                                                                    body={dobRender}
                                                                                    header="Date of Birth"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coreUserParentName"
                                                                                    body={parentRender}
                                                                                    header="Parent"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coreUserPhone"
                                                                                    body={phoneRender}
                                                                                    header="Phone"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="SportName"
                                                                                    body={sportRender}
                                                                                    header="Sport"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="ProgramName"
                                                                                    body={programRender}
                                                                                    header="Program"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coreUserAchievement"
                                                                                    body={acheivementRender}
                                                                                    header="Achievement"
                                                                                ></Column>
                                                                            </DataTable>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default studentReport;